import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import ls from 'local-storage';

const PublicRoute = ({ redirectPath = '/', children }) => {
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const applications = useSelector((state) => state.auth.currentUser.applications);

  let isValidRedirectPath = redirectPath;

  // If user has only one application, redirect to that application dashboard
  const lsUser = ls('user');
  if (!lsUser?.applications && lsUser?.application_uuid) {
    isValidRedirectPath = `/application/${lsUser.application_uuid}`;
  } else if (applications?.length === 1) {
    isValidRedirectPath = `/application/${applications[0].application_uuid}`;
  } else if (applications?.length > 1) {
    isValidRedirectPath = '/application';
  }

  if (isLoggedIn) return <Navigate to={isValidRedirectPath} replace state={{ from: location }}/>;
  return children;
};

PublicRoute.propTypes = {
  redirectPath: PropTypes.string,
  children: PropTypes.element,
};

export default PublicRoute;
